module.exports = __webpack_public_path__ + "img/get-more-sales.5552b7ae.png";